export const TYPE_IMAGE = 'picture';
export const TYPE_VIDEO = 'video';
